var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCollection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.15 5A2.85 2.85 0 0 1 9 2.15h6A2.85 2.85 0 0 1 17.85 5v1.279c1.159.362 2 1.443 2 2.721v1.279c1.159.362 2 1.443 2 2.721v6A2.85 2.85 0 0 1 19 21.85H5A2.85 2.85 0 0 1 2.15 19v-6c0-1.278.841-2.36 2-2.721V9c0-1.278.841-2.36 2-2.721zm1.7 1.15h8.3V5A1.15 1.15 0 0 0 15 3.85H9A1.15 1.15 0 0 0 7.85 5zm-2 4h12.3V9A1.15 1.15 0 0 0 17 7.85H7A1.15 1.15 0 0 0 5.85 9zM5 11.85A1.15 1.15 0 0 0 3.85 13v6c0 .635.515 1.15 1.15 1.15h14A1.15 1.15 0 0 0 20.15 19v-6A1.15 1.15 0 0 0 19 11.85z",
  clipRule: "evenodd"
})));
export default SvgCollection;